import Vue from 'vue'
import VueRouter from 'vue-router'
import { ref, watch } from "vue";
Vue.use(VueRouter)

import { pc } from "./pc"
import { mobile } from "./mobile"

// 声明变量用来接routers
var routes = [];
const screenWidth = ref();
let isDevice = "";
// 获取页面宽度
screenWidth.value = document.body.clientWidth;
if (screenWidth.value <= 768) {
    isDevice = "Mobile";
    routes = mobile
} else {
    isDevice = "pc";
    routes = pc
}
window.onresize = () => {
    screenWidth.value = document.body.clientWidth;
};

// 监听页面宽度
watch(screenWidth, (newVal, oldVal) => {
    let timer = setTimeout(() => {
        console.log("newVal:",newVal)
        let reset = "";
        if (newVal <= 768) {
            // 小于768就是移动端 就把移动端路由表赋给routes
            routes = mobile;
            reset = "Mobile";
        } else {
            // 大于就是pc端，把pc端路由表赋给routes
            routes = pc
            reset = "pc";
        }
        // 重绘页面
        if(reset != isDevice){
            isDevice = reset;
            console.log("重绘页面");
            window.location.reload()
        }
    }, 500)
    return () => {
        // 清除定时器
        clearTimeout(timer)
    }
}, {
    // 深度清除
    deep: true,
});


const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition){
    // 如果 savedPosition 存在，则保存它，否则返回顶部
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const hasRoute = router.getRoutes().some(route => route.path === to.path || route.name === to.name)
    if(!hasRoute){
        next('/')
    }else {
        next() // 如果有匹配的路由，正常跳转
    }
  if (from && to.meta && to.meta.refresh) {
    // 如果目标页面定义了 meta.refresh 为 true，则刷新页面
    // 注意：这里可以根据需要选择使用 router.go(0) 或 location.reload()
    window.location.reload();
    
    // 或者
    // router.go(0);
  }
  next();
});

export default router